export const makeTabsClose = (tabsContainer) => (
    ({target}) => {
        const element = target.closest(`div.tabs`);
            
        if (element !== tabsContainer && tabsContainer.classList.contains(`show-select`))
        {
            tabsContainer.classList.remove(`show-select`);
        } 
    }
);
